<template>
  <v-row>
    <v-col cols="12">
      <v-form ref="crudForm" @submit.prevent="submit">
        <v-row>
          <v-col cols="12" md="5" order-md="last">
            <v-row>
              <v-col cols="12">
                <v-text-field label="Date"
                              v-model="selectedDate"
                              :disabled="true"
                              :rules="rules.Date">
                  <template v-slot:label>
                    <v-icon style="vertical-align: middle">event</v-icon> Selected Date
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-date-picker full-width
                               v-model="selectedDate"></v-date-picker>
              </v-col>
            </v-row>
          </v-col>
          <v-spacer />
          <v-col cols="12" md="5" order-md="first">
            <v-row>
              <v-col cols="12">
                <v-text-field label="Title"
                              v-model="model.Title"
                              :rules="rules.Title" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn type="submit" color="primary" :loading="loading">
              {{ id ? 'Save' : 'Create' }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import FormMixins from '@/components/Mixins/Forms';
import { rules } from '@/util/Helpers';

export default {
  name: 'DayForm',
  mixins: [FormMixins],
  props: {
    Id: [String, Number],
    Title: String,
    Date: String,
  },
  data() {
    return {
      id: this.Id,
      model: {
        Title: this.Title,
        Date: this.Date,
      },
      rules: {
        Title: [
          (v) => rules.required(v, 'Please enter a Holiday Name'),
        ],
        Date: [
          (v) => rules.required(v, 'Please enter a Holiday Date'),
        ],
      },
      loading: false,
    };
  },
  computed: {
    selectedDate: {
      get() {
        return this.model.Date
          ? this.getISODateWithoutTime(this.model.Date)
          : null;
      },
      set(v) {
        this.model.Date = v;
      },
    },
  },
  methods: {
    getISODateWithoutTime(datestr) {
      const regex = new RegExp('^([0-9]{4}-[0-9]{2}-[0-9]{2})', 'gi');
      const ymd = datestr.match(regex);
      return ymd[0];
    },
    submit() {
      if (this.$refs.crudForm.validate()) {
        this.loading = true;
        if (this.id) {
          this.update();
        } else {
          this.create();
        }
        this.loading = false;
      } else {
        this.$refs.crudForm.inputs.every(this.goToFirstError);
      }
    },
    async create() {
      try {
        const response = await this.$store.dispatch('post', {
          api: 'Day',
          data: this.model,
        });
        this.$emit('snackbar', 'Holiday successfully created!');
        this.$emit('crud:create', response);
        this.$emit('crud:success', response);
        this.id = response.data.Id;
      } catch (e) {
        this.$emit('crud:error', e);
      }
    },
    async update() {
      try {
        const response = await this.$store.dispatch('put', {
          api: `Day/${this.id}`,
          data: this.model,
        });
        this.$emit('snackbar', 'Holiday successfully updated!');
        this.$emit('crud:update', response);
        this.$emit('crud:success', response);
      } catch (e) {
        this.$emit('crud:error', e);
      }
    },
  },
  created() {
  },
};
</script>
